const getStoredCookie = name => {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

if(getStoredCookie('cookies-popup') === undefined || getStoredCookie('cookies-popup') !== 'closed') {
  document.querySelector('.cookies-popup').style.display = 'block'

  setTimeout(() => {
    document.querySelector('.cookies-popup').classList.add('cookies-popup--animate')  
  }, 3000)  
}  

document.getElementById('cookiesTrigger').addEventListener('click', () => {
  document.querySelector('.cookies-popup').classList.remove('cookies-popup--animate')

  setTimeout(() => {
    document.querySelector('.cookies-popup').style.display = 'none'
  }, 3000)    
  document.cookie = `cookies-popup=closed; path=/; max-age=${60 * 60 * 24 * document.querySelector('.cookies-popup').dataset.cookies}`;
})  